import React from "react";
import RosePie from "charts/RosePie";

const data = [
  { name: "Opera", value: 10 },
  { name: "Firefox", value: 6379823 },
  { name: "Safari", value: 34047404 },
  { name: "IE", value: 952838153 },
  { name: "其他", value: 612476065 },
  { name: "Chrome", value: 3570624460 },
];

const Browser: React.FC = () => {
  return <RosePie data={data} roseType="radius" ring />;
};

export default Browser;
